import {Injectable} from '@angular/core';
import {ApiClientService} from '../api-client/api-client.service';
import {Observable, Subscriber} from 'rxjs';
import {ApiResponse} from '../../api/api-response';

@Injectable({
  providedIn: 'root'
})
export class RegisterService {

  constructor(private apiClient: ApiClientService) {
  }

  register(data: any): Observable<void> {
    return new Observable<void>((subscriber: Subscriber<any>): void => {
      this.apiClient.post('/register', {}, data, {ignoreBadRequest: true}).subscribe({
        next: (response: ApiResponse) => {
          subscriber.next(response.getData());
          subscriber.complete();
        },
        error: (error) => {
          subscriber.error(error);
          subscriber.complete();
        }
      });
    });
  }
}
